import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'pobble-components/dist/setup/sentry'

import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/app/app'
import ParentApp from './components/parent-app/parent-app'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from './reducer'
import { requestMiddleware } from 'pobble-components/dist/redux-helpers'
import 'normalize.css'
import { unregister } from './registerServiceWorker'
import { apiGetMe } from './common/api/profile'
import { PobbleStyles } from 'pobble-components/dist/styles'

import { PostHogProvider } from 'posthog-js/react'
import { posthog } from 'posthog-js'

window.posthog = posthog

// Remove previously applied service workers for a proper cache busting
unregister()

const store = createStore(
  rootReducer,
  applyMiddleware(requestMiddleware, thunk)
)

const posthogOptions = {
  api_host: 'https://eu.posthog.com',
  autocapture: false,
  capture_pageview: false,
  capture_pageleave: false,
  disable_session_recording: false
}

const render = ({ me, meError }) => {
  const isParent = me?.data?.account?.role_in_life === 'parent'
  ReactDOM.render(
    <PostHogProvider
      apiKey="phc_m6fAJjfR7jb7zKLkCtHOehLuDegky6k0xbDfdYxnWqs"
      options={posthogOptions}>
      <Provider store={store}>
        <PobbleStyles>
          {!isParent && <App me={me} meError={meError} />}
          {isParent && <ParentApp me={me} meError={meError} />}
        </PobbleStyles>
      </Provider>
    </PostHogProvider>,
    document.getElementById('root')
  )
}

apiGetMe({
  include:
    'account.timestamps,account.email_identity.email,account.signup_details,account.subscriptions,account.policy,account.subscription_policy,account.names,account.finish_signup_status,account.avatar,account.teacher_type.school.id,account.tutorials,account.pending_teacher_type.details,account.pending_teacher_type.school,account.pobbler_type'
}).then(res => render({ me: res }), e => render({ meError: e }))

// Lazy load external tools
setTimeout(() => import('pobble-components/dist/setup/external-tools'), 1000)
